module.exports = __webpack_public_path__ + "512fbbe247ac0dd4443b5ae8bd40ef59.png";